import React, { Component, createRef } from "react";
import RouteMenu from "VENDOR/CommonResources/RoutingMenu/RouteMenu";
import "../VendorQuotation/VendorQuotation.scss";
import "../VendorDelivery/vendorDelivery.scss";
import print from "../../CommonResources/print.png";
import expo from "../../CommonResources/export.png";
import { connect } from "react-redux";
import invoiceB from "../../CommonResources/invoiceB.png";
import status from "../../CommonResources/status.png";
import requested from "../../CommonResources/requested.png";
import expected from "../../CommonResources/expected.png";
import { ToastContainer, toast } from "react-toastify";
import insititute from "../../CommonResources/insititute.png";
import config from "config";
import vendorApiCall from "vendorApiCall";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ButtonLoader from "VENDOR/CommonResources/ButtonLoader/ButtonLoader";
import ExportJsonButton from "VENDOR/CommonResources/export/ExportExcelButton";
import Pagination from "react-js-pagination";
import ChalanView from "./chalan";
import ReactToPrint from "react-to-print";
import DeliveryChallan from "./newChalan";
// import ViewPO from "./ViewPO";
import * as XLSX from "xlsx";



let apiPath = "/vendor/api/vendor.php";
let apiPath1 = "/vendor/api/vendorDelivery.php";
const pageStyle = `
  @media print {
    @page {
      size: landscape;
      margin: 0.5cm;
    }

    body {
      font-size: 12px;
      -webkit-print-color-adjust: exact;
      color-adjust: exact;
    }

    table {
      width: 100%;
      border-collapse: collapse;
    }

    th, td {
      border: 1px solid #000;
      padding: 4px;
      text-align: left;
    }

    tr {
      page-break-inside: avoid;
    }

    .hidden-export-row {
      display: table-row !important;
    }

    input, select, button {
      display: none !important;
    }

    .icon-button, .pagination, .btn-submit, .btn-cancel, .quotation-input {
      display: none !important;
    }
  }
`;
const mockIsPOFetching = false;
class VendorDelivery extends Component {
  constructor(props) {
    super(props);
    this.printWrapperRef = createRef();
    this.state = {
      tableData: [],
      filterText: "",
      statusFilter: "",
      showModal: false,
      selectedRow: null,
      modalTableData: [],
      isLoading: false,
      activePage: 1,
      itemsPerPage: 10,
      totalItemsCount: 0,
      isPOFetching: false,
      POData: [],
      viewPOModal: false,
      purchaseOrder: "",

      // for add delivery
      showAddDeliveryModel: false,
      addDeliveryTitle: "",
      poList: [],
      selectedPoList: [],
      poIdSearch: "",
      filterIid: this.props.iidArray,
      poListLoader: false,
      poCount: 0,

      addLoader: false,
      deliveryList: [],
      filterDeliveryTitle: "",
      deliveryStatus: "",

      showSchedule: false,
      poDetails: [],
      expandedInstitutes: {},
      deliveryQuantities: {},

      showScheduleConfirm: false,
      showReScheduleConfirm: false,
      scheduleDate: "",

      selectedDeliveryId: "",
      selectedPoIdArray: [],

      showChalan: false,
      chalanList: [],

      showCancel: false,
      cancelText: "",
      confirmLoader: false,

      fetchDetails: false,
      loadingChallanId: null,

      deliveryStatus:"",

      poNameSearch: '',
      instituteFilter: '',
      filteredPoList: [],

      poNameSearchSelected: "",
      selectedInstitute: "",
    };
  }

  componentDidMount() {
    if (
     this.props.iidArray.length > 0
    ) {
      this.setState(
        {
          iidArray: this.props.iidArray,
        },
        () => {
          this.fetchDeliveryList();
        }
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(this.props.iidDetails) != JSON.stringify(prevProps.iidDetails)  
    ) {
      this.setState(
        {
          iidArray: this.props.iidArray,
        },
        () => {
          this.fetchDeliveryList();
        }
      );
    }
  }

  fetchPOForAddDelivery = async () => {
    this.setState({ poListLoader: true });
    const vendorArray = Object.keys(this.props.iidDetails).map(iid => {
      const details = this.props.iidDetails[iid]?.details;
      return details?.vendorId || null;
    }).filter(Boolean);

    const requestData = {
      iidArray: this.state.iidArray,
      vendorIdArray: vendorArray,
      status: this.state.poIdSearch,
    };

    let jsonResponse = await vendorApiCall.makeApiCall(
      "vendor_getRaisedPoForDelivery",
      requestData,
      apiPath1
    );
    const response = jsonResponse?.APIResult || {};
    if (response.success === "true") {
      const rawData = response.data;

      const formattedData = Object.keys(rawData)
        .reverse()
        .map((key, index) => {
          const item = rawData[key];

          return {
            srNo: index + 1,
            poId: item.poId,
            poName: item.poName,
            instituteName: item.instituteName,
            requestedOn: item.requestedOn,
          };
        });

      this.setState({ poList: formattedData, poCount: response.totalCount,  filteredPoList: formattedData });

    }
    this.setState({ isLoading: false });
  };

  fetchDeliveryList = async () => {
    this.setState({ isLoading: true,deliveryList:[] });

    const offset = (this.state.activePage - 1) * this.state.itemsPerPage;

    const vendorArray = Object.keys(this.props.iidDetails).map(iid => {
      const details = this.props.iidDetails[iid]?.details;
      return details?.vendorId || null;
    }).filter(Boolean);

    const requestData = {
      iidArray: this.props.iidArray,
      vendorIdArray: vendorArray,
      deliveryStatus: this.state.statusFilter,
      filterDeliveryTitle: this.state.filterDeliveryTitle,
      limit: this.state.itemsPerPage,
      offset,
    };

    let jsonResponse = await vendorApiCall.makeApiCall(
      "vendor_getDeliveryList",
      requestData,
      apiPath1
    );
    const response = jsonResponse?.APIResult || {};

    if (response.success === "true") {
      const rawData = response.data;

      const formattedData = Object.keys(rawData)
        .reverse()
        .map((key) => rawData[key]);

      this.setState({
        deliveryList: formattedData,
      });

      this.setState({
        deliveryList: formattedData,
        totalItemsCount: jsonResponse.APIResult.totalCount,
      });
    }
    this.setState({ isLoading: false });
  };

  fetchSelectedDeliveryDetails = async (poIdArray, deliveryId) => {
    this.setState({ fetchDetails: true });
    const requestData = {
      vendorId: config.instructorInfo.data.vendorId,
      poIdArray: poIdArray,
      deliveryId: deliveryId,
    };

    let jsonResponse = await vendorApiCall.makeApiCall(
      "vendor_getPoDetailsDelivery",
      requestData,
      apiPath1
    );
    const response = jsonResponse?.APIResult || {};

    if (response.success === "true") {
      const rawData = response.data;

      this.setState({
        poDetails: response.data,
      });
      let defaultQuantities = {};
Object.entries(response.data).forEach(([instituteId, institute]) => {
  Object.entries(institute.poDetails).forEach(([poId, po]) => {
    Object.entries(po.prDetails).forEach(([prId, pr]) => {
      if (!defaultQuantities[poId]) defaultQuantities[poId] = {};
      defaultQuantities[poId][prId] = pr.deliveryQuantity || pr.requiredQuantity || 1;  
    });
  });
});
this.setState({ deliveryQuantities: defaultQuantities });
    } else {
      toast.error("Something went Wrong");
    }
    this.setState({ fetchDetails: false });
  };

  fetchSelectedDeliveryDetailsForChalan = async (poIdArray, deliveryId,vendorId) => {
    this.setState({ fetchDetails: true });
    const requestData = {
      vendorId: vendorId,
      poIdArray: poIdArray,
      deliveryId: deliveryId,
    };

    let jsonResponse = await vendorApiCall.makeApiCall(
      "vendor_getChalans",
      requestData,
      apiPath1
    );
    const response = jsonResponse?.APIResult || {};

    if (response.success === "true") {
      const rawData = response.data;

      this.setState({
        chalanList: response.data,
        showChalan: true,
      });
    } else {
      toast.error("Something went Wrong");
    }
    this.setState({ fetchDetails: false, loadingChallanId:null });
  };
  calculateCountdown = (expectedDate) => {
    const currentDate = new Date();
    const targetDate = new Date(expectedDate);

    const differenceInMs = targetDate - currentDate;
    const differenceInDays = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));

    if (differenceInDays < 0) {
      return "Expired";
    } else if (differenceInDays === 0) {
      return "Today";
    } else {
      return `Within ${differenceInDays} Days`;
    }
  };

  handleFilterChange = (e) => {
    this.setState(
      { filterDeliveryTitle: e.target.value, activePage: 1, offset:0 },
      this.fetchDeliveryList
    );
  };

  handleStatusChange = (e) => {
    this.setState(
      { statusFilter: e.target.value, activePage: 1, offset:0 },
      this.fetchDeliveryList
    );
  };

  handleChallanClick = (poIdArray, deliveryId, vendorId) => {
    this.setState(
      {
        selectedDeliveryId: deliveryId,
        selectedPoIdArray: poIdArray,
      },
      () => {
        this.fetchSelectedDeliveryDetailsForChalan(poIdArray, deliveryId, vendorId);
      }
    );
  };

  handlePageChange = (pageNumber) => {
    this.setState({ activePage: pageNumber }, this.fetchDeliveryList);
  };

  handlePrint = () => {
    const originalContents = document.body.innerHTML;
    const modalContents = document.querySelector(
      ".modalDataContainer"
    ).innerHTML;

    document.body.innerHTML = modalContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
  };

  formatDate = (dateString) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const date = new Date(dateString);

    if (isNaN(date)) {
      return "Invalid Date";
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  closeModal = () => {
    this.setState({
      showAddDeliveryModel: false,
      selectedRow: null,
      modalTableData: [],
      selectedPoIdArray:[],
      selectedPoList:[],
    });
  };

  handleSelectPO = (po) => {
    // Prevent duplicates
    const alreadySelected = this.state.selectedPoList.some(
      (item) => item.poName === po.poName
    );
    if (!alreadySelected) {
      this.setState((prevState) => ({
        selectedPoList: [...prevState.selectedPoList, po],
      }));
    }
  };

  handleRemovePO = (po) => {
    this.setState((prevState) => ({
      selectedPoList: prevState.selectedPoList.filter(
        (item) => item.poName !== po.poName
      ),
    }));
  };

  addDeliveryApiCall = async () => {
    if (this.state.addDeliveryTitle == "") {
      toast.error("Please enter delivery title first");
      return;
    }
   

    let poIdArray = this.state.selectedPoList.map((po) => po.poId);
    if (poIdArray.length == 0) {
      toast.error("Please select po first");
      return;
    }
    this.setState({
      addLoader: true,
    });
    const vendorArray = Object.keys(this.props.iidDetails).map(iid => {
      const details = this.props.iidDetails[iid]?.details;
      return details?.vendorId || null;
    }).filter(Boolean);

    const requestData = {
      vendorIdArray: vendorArray,
      vendorId:config.instructorInfo.data.vendorId,
      poIdArray: poIdArray,
      deliveryTitle: this.state.addDeliveryTitle,
    };

    let jsonResponse = await vendorApiCall.makeApiCall(
      "vendor_addDelivery",
      requestData,
      apiPath1
    );

    const response = jsonResponse?.APIResult || {};
    if (response.success) {
      toast.success(response.message);
      this.setState({ addLoader: false, showAddDeliveryModel: false },()=> this.fetchDeliveryList());

    }else{
      toast.warning(response.message);
      this.setState({ addLoader: false, showAddDeliveryModel: false });
    }
  };

  handlePoNameSearch = (searchText) => {
    this.setState({ poNameSearch: searchText }, this.applyFilters);
  };
  
  handleInstituteFilter = (selectedInstitute) => {
    this.setState({ instituteFilter: selectedInstitute }, this.applyFilters);
  };

  handlePoNameChange = (e) => {
    this.setState({ poNameSearchSelected: e.target.value });
  };
  
  handleInstituteChange = (e) => {
    this.setState({ selectedInstitute: e.target.value });
  };
  applyFilters = () => {
    const { poList, poNameSearch, instituteFilter } = this.state;
  
    const filtered = poList.filter((po) => {
      const matchesPo = po.poName.toLowerCase().includes(poNameSearch.toLowerCase());
      const matchesInstitute = instituteFilter
        ? po.instituteName === instituteFilter
        : true;
  
      return matchesPo && matchesInstitute;
    });
  
    this.setState({ filteredPoList: filtered });
  };

  addDeliveryModal = () => {
    const { showAddDeliveryModel, modalTableData, isLoading, quotationNumber } =
      this.state;
    if (!showAddDeliveryModel) return null;

    const filteredPoList = this.state.selectedPoList.filter((po) => {
      const matchesPoName = po.poName
        .toLowerCase()
        .includes(this.state.poNameSearchSelected.toLowerCase());
    
      const matchesInstitute = this.state.selectedInstitute
        ? po.instituteName === this.props.iidDetails[this.state.selectedInstitute]?.details?.instituteName
        : true;
    
      return matchesPoName && matchesInstitute;
    });

    return (
      <div className="delivery-modal">
        <div className="delivery-modal-content">
          {/* Modal Header */}
          <div
            className="modal-header"
            style={{
              color: "#202020",
              background: "white",
              border: "none",
              cursor: "pointer",
            }}
          >
            <h3>Add Delivery</h3>
            <div>
              <FontAwesomeIcon
                icon={["fas", "times"]}
                onClick={this.closeModal}
              />
            </div>
          </div>
          {/* Modal Body */}
          <div className="modal-body">
            <div className="p-2">
              <p>
                Delivery Title <span className="text-danger"> * </span>
              </p>
              <input
                type="text"
                className="form control"
                style={{ width: "400px" }}
                placeholder="Enter delivery title"
                onChange={(e) => {
                  this.setState({ addDeliveryTitle: e.target.value });
                }}
              ></input>
            </div>

            <div className="d-flex ">
              <div className="w-100 border rounded p-3 mx-1">
                <div className="parent-header">
                  <div className="form-group">
                    <label htmlFor="po-id">PO Name</label>
                    <input
                        type="text"
                        id="po-id"
                        className="form-control"
                        placeholder="Search by PO Name"
                        value={this.state.poNameSearch}
                        onChange={(e) => this.handlePoNameSearch(e.target.value)}
                      />
                  </div>
                  <div className="form-group">
                    <label htmlFor="institute">Institute</label>
                    <select
                        id="institute"
                        className="form-control p-0"
                        onChange={(e) => this.handleInstituteFilter(e.target.value)}
                        value={this.state.instituteFilter}
                      >
                        <option value="">All Institute</option>
                        {Object.entries(this.props.iidDetails).map(([key, value]) => (
                          <option key={key} value={value.details.instituteName}>
                            {value.details.instituteName}
                          </option>
                        ))}
                      </select>
                  </div>
                </div>
                <div
                  className=" d-flex justify-content-between"
                  style={{ fontSize: "12px" }}
                >
                  <p>PO List</p>
                  <p>{this.state.poCount} Records</p>
                </div>
                <div>
                  {this.state.filteredPoList.length > 0
                    ? this.state.filteredPoList.map((row, index) => {
                        const isSelected = this.state.selectedPoList.some(
                          (item) => item.poName === row.poName
                        );

                        return (
                          <div
                            key={index}
                            className="po-item d-flex justify-content-between align-items-center border p-2 mb-2 rounded"
                            style={{
                              cursor: "pointer",
                              backgroundColor: "#f8f9fa",
                            }}
                            onClick={() => this.handleSelectPO(row)}
                          >
                            <div>
                              <p>
                                <strong>PO :</strong> {row.poName}
                              </p>
                              <p>
                                <small>Requested on : {row.requestedOn}</small>
                              </p>
                              <p>
                                <small>{row.instituteName}</small>
                              </p>
                            </div>
                            <div>
                              <FontAwesomeIcon
                                icon={["fas", "check-circle"]}
                                size="lg"
                                style={{
                                  color: isSelected ? "#28a745" : "#dcdcdc",
                                }} // Green if selected, light grey otherwise
                              />
                            </div>
                          </div>
                        );
                      })
                    : (<>{this.state.poNameSearch === "" ? "No PO avilable for add delivery" : "No PO avilable as per applied filter"}</>)}
                </div>
              </div>

              <div className="w-100 border rounded p-3 mx-4">
                <div className="parent-header">
                  <div className="form-group">
                    <label htmlFor="po-id">PO Name</label>
                    <input
                          type="text"
                          id="po-id"
                          className="form-control"
                          placeholder="Search by PO Name"
                          value={this.state.poNameSearchSelected}
                          onChange={this.handlePoNameChange}
                        />
                  </div>
                  <div className="form-group">
                    <label htmlFor="institute">Institute</label>
                    <select
                      id="institute"
                      className="form-control p-0"
                      onChange={this.handleInstituteChange}
                      value={this.state.selectedInstitute}
                    >
                      <option value="">All Institute</option>
                      {Object.entries(this.props.iidDetails).map(([key, value]) => (
                        <option value={key}>{value.details.instituteName}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="d-flex justify-content-between">
                  <p style={{ fontSize: "12px" }}>Selected POs</p>
                  <p style={{ fontSize: "12px" }}>
                    {this.state.selectedPoList.length} Records
                  </p>
                </div>
                <div>
                {filteredPoList.length > 0 ? (
                  filteredPoList.map((row, index) => (
                    <div
                      key={index}
                      className="po-item d-flex justify-content-between align-items-center border p-2 mb-2 rounded"
                      style={{ backgroundColor: "#f8f9fa" }}
                    >
                      <div>
                        <p>
                          <strong>PO :</strong> {row.poName}
                        </p>
                        <p>
                          <small>Requested on : {row.requestedOn}</small>
                        </p>
                        <p>
                          <small>{row.instituteName}</small>
                        </p>
                      </div>
                      <div>
                        <FontAwesomeIcon
                          icon={["fas", "minus-circle"]}
                          size="lg"
                          style={{ color: "#dc3545", cursor: "pointer" }}
                          onClick={() => this.handleRemovePO(row)}
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <p>{this.state.poNameSearchSelected ==="" ? "No POs Selected ":"No POs  matched the filter"}</p>
)}
                </div>
              </div>
            </div>
          </div>

          {/* Modal Footer */}
          <div className="modal-footer" style={{ justifyContent: "flex-end" }}>
            {this.state.addLoader ? <ButtonLoader /> : ""}
            <button
              className="btn border"
              onClick={() => this.setState({ showAddDeliveryModel: false })}
              style={{ background: "", color: "black" }}
            >
              Cancel
            </button>

            <button
              className="btn bg-primary"
              onClick={() => this.addDeliveryApiCall()}
              style={{ color: "white" }}
            >
              Add
            </button>
          </div>
        </div>
      </div>
    );
  };

  toggleInstitute = (instituteId) => {
    this.setState((prevState) => ({
      expandedInstitutes: {
        ...prevState.expandedInstitutes,
        [instituteId]: !prevState.expandedInstitutes[instituteId], // toggle
      },
    }));
  };

  handleQuantityChange = (poId, prId, requiredQty, value) => {
    if (value === "") {
      // Allow temporary blank input while user is typing
      this.setState((prevState) => {
        const updatedQuantities = { ...prevState.deliveryQuantities };
        if (!updatedQuantities[poId]) updatedQuantities[poId] = {};
        updatedQuantities[poId][prId] = "";
        return { deliveryQuantities: updatedQuantities };
      });
      return;
    }
  
    const numericValue = Number(value);
  
    if (numericValue <= 0) {
      toast.error("Quantity must be greater than 0");
      return;
    }
  
    if (numericValue > requiredQty) {
      toast.error("Quantity cannot be greater than Required Quantity");
      return;
    }
    if (numericValue < requiredQty) {
      toast.error("Quantity cannot be less than Required Quantity");
      return;
    }
  
    this.setState((prevState) => {
      const updatedQuantities = { ...prevState.deliveryQuantities };
      if (!updatedQuantities[poId]) updatedQuantities[poId] = {};
      updatedQuantities[poId][prId] = numericValue;
      return { deliveryQuantities: updatedQuantities };
    });
  };

  scheduleDelivery = async (status) => {
    this.setState({ confirmLoader: true });

    if (status == "cancel") {
      if (this.state.cancelText != "YES") {
        toast.error("Please Enter confirmation correctly.");
        return;
      }
    }
    const requestData = {
      vendorId: config.instructorInfo.data.vendorId,
      scheduleStatus: status,
      deliveryDate: this.state.scheduleDate,
      deliveryId: this.state.selectedDeliveryId,
      poDetails: this.state.deliveryQuantities,
    };
    let jsonResponse = await vendorApiCall.makeApiCall(
      "vendor_scheduleSaveDelivery",
      requestData,
      apiPath1
    );
    const response = jsonResponse?.APIResult || {};

    if (response.success === "true") {
      toast.success(jsonResponse?.APIResult?.message);
    }
    this.setState({
      confirmLoader: false,
      showScheduleConfirm: false,
      showReScheduleConfirm: false,
      showSchedule:false,
    }, ()=> this.fetchDeliveryList());
  };

  cancelDelivery = async (status) => {
    this.setState({ confirmLoader: true });

    if (status == "cancel") {
      if (this.state.cancelText != "YES") {
        toast.error("Please Enter confirmation correctly.");
        return;
      }
    }

    const requestData = {
      vendorId: config.instructorInfo.data.vendorId,
      scheduleStatus: status,
      deliveryId: this.state.selectedDeliveryId,
      poIdArray: this.state.selectedPoIdArray,
    };
    let jsonResponse = await vendorApiCall.makeApiCall(
      "vendor_cancelDelivery",
      requestData,
      apiPath1
    );
    const response = jsonResponse?.APIResult || {};

    if (response.success === "true") {
      toast.success(jsonResponse?.APIResult?.message);
    }
    this.setState({ confirmLoader: false, showCancel: false });
  };

  openSchedule = () => {
    if (!this.state.showSchedule) return null;

    const poDetails = this.state.poDetails?.data || {};
    const tableHeaderStyle = {
      padding: "8px",
      border: "1px solid #ddd",
      textAlign: "left",
    };

    const tableCellStyle = {
      padding: "8px",
      border: "1px solid #ddd",
      textAlign: "left",
    };
    return (
      <>
        <div className="delivery-modal">
          <div
            className="delivery-modal-content"
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            {/* Modal Header */}
            <div
              className="modal-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                color: "#202020",
                background: "white",
                border: "none",
                cursor: "pointer",
                paddingBottom: "1rem",
                borderBottom: "1px solid #eee",
              }}
            >
              <h3>Schedule Delivery</h3>
              <FontAwesomeIcon
                icon={["fas", "times"]}
                onClick={() => this.setState({ showSchedule: false })}
              />
            </div>

            {/* Modal Body */}
            <div className="modal-body" style={{ display: "flex" }}>
              {/* Left Panel: Institute Wise PO List */}
              <div
                className="left-panel"
                style={{
                  flex: "1",
                  background: "#F7F7F7",
                  padding: "1rem",
                  borderRadius: "8px",
                  overflowY: "auto",
                  height: "100%",
                }}
              >
                <h4 style={{ marginBottom: "0.5rem" }}>
                  Institute Wise PO List
                </h4>
                {Object.entries(this.state.poDetails).map(
                  ([instituteId, institute]) => {
                    const isExpanded =
                      this.state.expandedInstitutes[instituteId];

                    return (
                      <div key={instituteId} style={{ marginBottom: "1rem" }}>
                        <div
                          onClick={() => this.toggleInstitute(instituteId)}
                          style={{
                            fontWeight: "bold",
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            cursor: "pointer",
                            padding: "0.5rem",
                            background: "#fff",
                            border: "1px solid #ddd",
                            borderRadius: "6px",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={
                              isExpanded
                                ? ["fas", "chevron-up"]
                                : ["fas", "chevron-down"]
                            }
                          />
                          <span className="ml-2">
                            {institute.instituteName}
                          </span>
                        </div>

                        {isExpanded && (
                          <div>
                            {Object.entries(institute.poDetails).map(
                              ([poId, po]) => (
                                <div
                                  key={poId}
                                  style={{
                                    padding: "0.5rem",
                                    background: "#f9f9f9",
                                    borderBottom: "1px solid #ddd",
                                    borderLeft: "1px solid #ddd",
                                    borderRight: "1px solid #ddd",
                                    borderRadius: "0px",
                                  }}
                                >
                                  {po.poName}
                                </div>
                              )
                            )}
                          </div>
                        )}
                      </div>
                    );
                  }
                )}

                <div
                  className="delivery-modal-footer"
                  style={{
                    position: "absolute",
                    bottom: 4,
                    display: "flex",
                    gap: "1rem",
                  }}
                >
                  <button
                    className="btn bg-primary text-white border"
                    onClick={() => {
                      const deliveryQuantities = this.state.deliveryQuantities || {};

                      const allQuantities = Object.values(deliveryQuantities)
                        .flatMap(q => Object.values(q));

                      const hasZeroQty = allQuantities.some(q => Number(q) === 0);

                      if (hasZeroQty || allQuantities.length === 0) {
                        toast.error("Quantity must be greater than zero for all items.");
                        return;
                      }

                      this.setState({ showScheduleConfirm: true });
                    }}
                  >
                    {this.state.showReScheduleConfirm ? "Initiate" : "Schedule"}
                  </button>

                  <button
                    className="btn"
                    onClick={() => this.scheduleDelivery("save")}
                    style={{
                      background: "#E0E5EB",
                      color: "#2D4969",
                      padding: "0.5rem 1.5rem",
                      borderRadius: "5px",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    Save
                  </button>

                  <button
                    className="btn"
                    onClick={() => this.setState({ showSchedule: false })}
                    style={{
                      background: "white",
                      color: "black",
                      padding: "0.5rem 1.5rem",
                      borderRadius: "6px",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>

              {/* Right Panel: Asset List */}
              <div
                className="right-panel"
                style={{
                  flex: "2",
                  background: "#ffffff",
                  padding: "1rem",
                  borderRadius: "8px",
                  border: "1px solid #eee",
                  overflowY: "auto",
                  maxHeight: "100%",
                }}
              >
                <h4 style={{ marginBottom: "0.5rem" }}>Asset List</h4>
                {Object.entries(this.state.poDetails).map(
                  ([instituteId, institute]) =>
                    Object.entries(institute.poDetails).map(([poId, po]) => (
                      <div key={poId} style={{ marginBottom: "1.5rem" }}>
                        <div
                          style={{ fontWeight: "bold", marginBottom: "0.5rem" }}
                        >
                          {institute.instituteName}
                          <br />
                          {po.poName}
                        </div>

                        <table
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            marginBottom: "1rem",
                            fontSize: "0.9rem",
                          }}
                        >
                          <thead>
                            <tr style={{ background: "#F7F7F7" }}>
                              <th style={tableHeaderStyle}>Sr. No.</th>
                              <th style={tableHeaderStyle}>Asset Name</th>
                              <th style={tableHeaderStyle}>
                                Required Quantity
                              </th>
                              <th style={tableHeaderStyle}>Amount Per Unit</th>
                              <th style={tableHeaderStyle}>Quantity</th>
                              <th style={tableHeaderStyle}>Total Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.entries(po.prDetails).map(
                              ([prId, pr], idx) => (
                                <tr key={prId}>
                                  <td style={tableCellStyle}>
                                    {String(idx + 1).padStart(2, "0")}.
                                  </td>
                                  <td style={tableCellStyle}>
                                    {pr.catalogName}
                                  </td>
                                  <td style={tableCellStyle}>
                                    {pr.requiredQuantity} Units
                                  </td>
                                  <td style={tableCellStyle}>
                                    ₹ {pr.amountPerUnit.toFixed(4)}
                                  </td>
                                  <td style={tableCellStyle}>
                                    <input
                                      type="number"
                                      value={
                                        this.state.deliveryQuantities[poId]?.[
                                          prId
                                        ] ?? pr.deliveryQuantity
                                      }
                                      onChange={(e) =>
                                        this.handleQuantityChange(
                                          poId,
                                          prId,
                                          pr.requiredQuantity,
                                          e.target.value
                                        )
                                      }
                                      onKeyDown={(e) => {
                                        if (e.key === 'e' || e.key === 'E' || e.key === '-' || e.key === '+' || e.key === '.') { 
                                            e.preventDefault(); 
                                        }
                                    }}
                                      style={{
                                        width: "60px",
                                        padding: "4px",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                      }}
                                    />
                                  </td>
                                  <td style={tableCellStyle}>
                                    ₹{" "}
                                    {(
                                      pr.amountPerUnit *
                                      (this.state.deliveryQuantities[poId]?.[
                                        prId
                                      ] ?? pr.deliveryQuantity)
                                    ).toFixed(4)}
                                  </td>
                                </tr>
                              )
                            )}
                            <tr
                              style={{
                                fontWeight: "bold",
                                background: "#F7F7F7",
                              }}
                            >
                              <td style={tableCellStyle}>-</td>
                              <td style={tableCellStyle}>Total</td>
                              <td style={tableCellStyle}> {" "}
                                {Object.values(po.prDetails)
                                  .reduce(
                                    (acc, pr) => acc + pr.requiredQuantity,
                                    0
                                  )
                                  .toFixed(2)}</td>
                              <td style={tableCellStyle}>
                                ₹{" "}
                                {Object.values(po.prDetails)
                                  .reduce(
                                    (acc, pr) => acc + pr.amountPerUnit,
                                    0
                                  )
                                  .toFixed(2)}
                              </td>
                              <td style={tableCellStyle}>-</td>
                              <td style={tableCellStyle}>
                                ₹{" "}
                                {Object.values(po.prDetails)
                                  .reduce(
                                    (acc, pr) =>
                                      acc +
                                      pr.amountPerUnit * pr.requiredQuantity,
                                    0
                                  )
                                  .toFixed(4)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    ))
                )}
              </div>
            </div>

            {/* Modal Footer */}
          </div>
        </div>
      </>
    );
  };

  openScheduleConfirmation = () => {
    if (!this.state.showScheduleConfirm) return null;
    return (
      <>
        <div className="delivery-confirm-modal">
          <div
            className="delivery-confirm-modal-content"
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            <div
              className="modal-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                color: "#202020",
                background: "white",
                border: "none",
                cursor: "pointer",
                paddingBottom: "1rem",
                borderBottom: "1px solid #eee",
              }}
            >
              <h3>
                {this.state.showReScheduleConfirm
                  ? "Re-Schedule Delivery"
                  : " Schedule Delivery"}
              </h3>
              <FontAwesomeIcon
                icon={["fas", "times"]}
                onClick={() => this.setState({ showScheduleConfirm: false })}
              />
            </div>
            <div
              className="delivery-confirm-modal-body"
              style={{ display: "flex" }}
            >
              <input
                type="date"
                className="form-control"
                onChange={(e) =>
                  this.setState({ scheduleDate: e.target.value })
                }
              ></input>
              <div className="confirmation ">
                <div></div>
                <div style={{ display: "flex", gap: "1rem" }}>
                  <button
                    className="btn border"
                    onClick={() => {
                      this.setState({ showScheduleConfirm: false });
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn bg-primary text-white border"
                    onClick={() => {
                      this.scheduleDelivery("scheduled");
                    }}
                  >
                    {this.state.showReScheduleConfirm ? "Initiate" : "Schedule"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  openDeliveryCancelConfirmation = () => {
    if (!this.state.showCancel) return null;
    return (
      <>
        <div className="delivery-confirm-modal">
          <div
            className="delivery-confirm-modal-content"
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            <div
              className="modal-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                color: "#202020",
                background: "white",
                border: "none",
                cursor: "pointer",
                paddingBottom: "1rem",
                borderBottom: "1px solid #eee",
              }}
            >
              <h3>Are you sure?</h3>
              <FontAwesomeIcon
                icon={["fas", "times"]}
                onClick={() => this.setState({ showCancel: false })}
              />
            </div>
            <div
              className="delivery-confirm-modal-body"
              style={{ display: "flex" }}
            >
              <p style={{ fontSize: "14px", paddingBottom: "15px" }}>
                Once the delivery is canceled, this action cannot be undone.{" "}
                <br />
                To confirm the cancellation, please enter "YES" in uppercase
                letters.
              </p>
              <input
                type="text"
                className="form-control"
                placeholder="Enter 'YES' in block letters."
                onChange={(e) => this.setState({ cancelText: e.target.value })}
              ></input>
              <div className="confirmation-chalan">
                <div></div>
                <div style={{ display: "flex", gap: "1rem" }}>
                  <button
                    className="btn border text-black bg-white"
                    onClick={() => {
                      this.setState({ showCancel: false });
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn bg-danger text-white border"
                    onClick={() => {
                      this.cancelDelivery("cancel");
                    }}
                  >
                    Cancel Delivery
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  openViewChalan = () => {
    if (!this.state.showChalan) return null;

    const chalanList = this.state.chalanList || {};

    return (
      <>
        <div className="delivery-chalan-modal">
          <div
            className="delivery-chalan-modal-content"
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            {/* Modal Header */}
            <div
              className="modal-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                color: "#202020",
                background: "white",
                border: "none",
                cursor: "pointer",
                paddingBottom: "1rem",
                borderBottom: "1px solid #eee",
              }}
            >
              <h3>Delivery Chalan</h3>

              <div>
                <ReactToPrint
                  trigger={() => <img src={print} />}
                  content={() => this.printWrapperRef.current}
                />
                <FontAwesomeIcon
                  icon={["fas", "times"]}
                  onClick={() => this.setState({ showChalan: false })}
                  style={{ marginLeft: "8px" }}
                />
              </div>
            </div>

            {/* Modal Body */}
            <div
              className="delivery-chalan-modal-body"
              style={{ display: "flex" }}
            >
              <div style={{ overflowX: "auto", height: "80vh" }}>
                <div ref={this.printWrapperRef}>
                  {Object.entries(chalanList).map(
                    ([instituteId, instituteData]) => {
                      const poDetails = instituteData.poDetails || {};
                      const vendorDetails = instituteData.vendorDetails || {};
                      const instituteName = instituteData.instituteName || "";
                      const instituteDetails = instituteData.details || "";

                      return (
                        <div key={instituteId}>
                          {Object.entries(poDetails).map(([poId, poData]) => (
                            <ChalanView
                              key={poId}
                              data={{
                                poId,
                                poData,
                                vendorDetails,
                                instituteName,
                                instituteDetails
                              }}
                            />
                          ))}
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div
              className="modal-footer"
              style={{ justifyContent: "flex-end", gap: "1rem" }}
            >

              {this.state.deliveryStatus != "Accepted" ? 
              
              <>
              
              <button
                className="btn btn-primary "
                style={{ marginTop: "-8px" }}
                onClick={() => {
                  this.setState({
                    showScheduleConfirm: true,
                    showReScheduleConfirm: true,
                  });
                }}
              >
                Re-Schedule
              </button>
              <button
                className="btn bg-white text-danger "
                style={{ marginTop: "-8px" }}
                onClick={() => {
                  this.setState({ showCancel: true });
                }}
              >
                Cancel Delivery
              </button>
              </>
            :""}
            </div>
          </div>
        </div>
      </>
    );
  };

 exportRenderedTableToExcel = () => {
        const originalTable = this.tableRef;
      
        if (!originalTable) {
          toast.error("Table not found.");
          return;
        }
      
    
        const clonedTable = originalTable.cloneNode(true);
      
        const hiddenRows = clonedTable.querySelectorAll(".hidden-export-row");
        hiddenRows.forEach((row) => {
          row.style.display = "table-row";
        });
      
    
        clonedTable.style.position = "absolute";
        clonedTable.style.left = "-9999px";
        document.body.appendChild(clonedTable);
      
        const wb = XLSX.utils.table_to_book(clonedTable, { sheet: "Quotations" });
        XLSX.writeFile(wb, "Delivery schedule.xlsx");
      
        document.body.removeChild(clonedTable);
      };

  handleExport = () => {
    this.exportRenderedTableToExcel();
  };

  
  render() {
    const { isLoading } = this.state;
    const statusOptions = [
      { value: "initiated", label: "Initiated" },
      { value: "pending", label: "Pending" },
      { value: "cancel", label: "Cancelled" },
      { value: "scheduled", label: "Scheduled" },
      { value: "accepted", label: "Accepted" },
    ];
    return (
      <div>
        <RouteMenu />
      <div className="modalDataContainer">

        <div className="quotation-main">
          <div className="quotation-header">
            <div className="d-flex align-items-center justify-content-between">
              <div className="col">

              <h3>Delivery Schedule</h3>
              <p style={{ fontSize: "12px" }}>
              On this delivery screen you can add deliveries and schedule deliveries.
            </p>
              </div>
              <button
                className="btn"
                style={{
                  fontSize: "14px",
                  background: "#2265AC",
                  color: "white",
                }}
                onClick={() => {
                  this.setState({ showAddDeliveryModel: true }, () =>
                    this.fetchPOForAddDelivery()
                  );
                }}
              >
                <FontAwesomeIcon icon={["fas", "plus"]} />
                Add delivery
              </button>
            </div>
          </div>
          <div
            className="seprator"
            style={{
              borderBottom: "1px solid #AAAAAA",
              height: "3px",
              width: "100%",
              marginBottom: "15px",
            }}
          ></div>
          <div className="quotation-filter">
            <div className="filters">
              <input
                type="text"
                placeholder="Search "
                value={this.state.filterDeliveryTitle}
                onChange={this.handleFilterChange}
              />
              <select
                onChange={this.handleStatusChange}
                value={this.state.statusFilter}
              >
                <option value="">All Status</option>
                <option value="initiated">Initiated</option>
                <option value="pending">Pending</option>
                <option value="scheduled">Scheduled</option>
                <option value="rejected">Rejected</option>
                <option value="accepted">Accepted</option>
                <option value="cancel">Cancelled</option>
              </select>
            </div>
            <div>

            

              <ReactToPrint
                trigger={() => 
                  <button  className="icon-button">
                    <img src={print} alt="Print Icon"   />
                   
                  </button>
                }
                pageStyle={pageStyle}
                content={() => this.tableRef}
                />

              <button
                aria-label="Print"
                className="icon-button"
                onClick={this.handleExport}
                title="Click here to export the entries to excel file"

              >
                <img src={expo} alt="Export" />
              </button>
              
            </div>
          </div>

        <div  className="clear-filters">
          <p>{(this.state.filterDeliveryTitle !== "" || this.state.statusFilter !==  "") ? "Filters are applied.": ""}</p>
          
          <div
            style={{
              color:'#007bff',
              cursor:'pointer'
            }}
            onClick={() =>
              this.setState(
                { filterDeliveryTitle: "", statusFilter: "", activePage: 1, offset:0 },
                this.fetchDeliveryList
              )
            }
          >
            <u>Clear All</u>
          </div>

        </div>
          <div className="table-scroll-container ">
            <table ref={(ref) => (this.tableRef = ref)} className="quotation-table">
              <thead>
                 <tr
                    className="hidden-export-row"
                   
                  >
                    <th colSpan="6" >
                        <p style={{
                          display:"flex",
                          justifyContent:"center",
                          textAlign: "center",
                          verticalAlign: "middle",
                          fontWeight: "bold",
                          fontSize: "16px",
                          
                        }}>Delivery Schedule</p>
                    </th>
                </tr>

                {(this.state.filterText || this.state.statusFilter || this.state.selectedInstitute) && (
                    <tr className="hidden-export-row">
                      <th colSpan="10">
                        {this.state.filterText && `Delivery title: ${this.state.filterDeliveryTitle}`}
                        {this.state.statusFilter &&
                            ` | Status: ${ statusOptions.find(opt => opt.value === this.state.statusFilter)?.label}`}
                        {this.state.selectedInstitute &&
                          ` | Institute: ${
                            this.props.iidDetails[this.state.selectedInstitute]?.details
                              ?.instituteName || this.state.selectedInstitute
                          }`}
                      </th>
                    </tr>
                  )}
                <tr>
                  <th>Sr. No.</th>

                  <th>Delivery Title</th>
                  <th>Delivered To</th>
                  <th>PO Count</th>
                  <th>Requested On</th>
                  {/* <th>Customer Remark</th> */}
                  <th>Delivery Status</th>
                  <th  className="hidePrint">Action</th>
                </tr>
              </thead>
              <tbody>
                {Object.values(this.state.deliveryList).length > 0 ? (
                  Object.values(this.state.deliveryList).map(
                    (delivery, deliveryIndex) => {
                      const deliveryDetailsArray = delivery.deliveryDetails
                        ? Object.values(delivery.deliveryDetails)
                        : [];

                      if (deliveryDetailsArray.length === 0) {
                        // If no deliveryDetails, render single row
                        return (
                          <tr key={`delivery-${delivery.deliveryId}`}>
                            <td >{(this.state.activePage - 1) * this.state.itemsPerPage + deliveryIndex + 1}</td>
                            <td>{delivery.deliveryTitle}</td>
                            <td colSpan="5" style={{ textAlign: "center" }}>
                              No delivery details available.
                            </td>
                          </tr>
                        );
                      } else {
                        // If there are deliveryDetails, render with rowSpan
                        return deliveryDetailsArray.map(
                          (detail, detailIndex) => (
                            <tr
                              key={`delivery-${delivery.deliveryId}-detail-${detail.deliveryToId}`}
                            >
                              {detailIndex === 0 && (
                                <>
                                  <td rowSpan={deliveryDetailsArray.length}>
                                    <td style={{border:'none', padding:'0px'}}>{(this.state.activePage - 1) * this.state.itemsPerPage + deliveryIndex + 1}</td>

                                  </td>
                                  <td rowSpan={deliveryDetailsArray.length}>
                                    {delivery.deliveryTitle}
                                  </td>
                                </>
                              )}
                              <td>{detail.deliveryTo}</td>
                              <td>{detail.poCount}</td>
                              <td>{detail.requestedOn}</td>{" "}
                              {/* Requested On is not provided in your object */}
                              {/* <td>{detail.customerRemark || "-"}</td> */}
                              <td>
                              <div>
                                    {detail.pending !== 0 && (
                                      <p className={`status pending`}>{`${detail.pending} Pending`}</p>
                                    )}
                                    {detail.initiated !== 0 && (
                                      <p className={`status initiated`}>{`${detail.initiated} Initiated`}</p>
                                    )}
                                    {detail.scheduled !== 0 && (
                                      <p className={`status scheduled`}>{`${detail.scheduled} Scheduled`}</p>
                                    )}
                                    {detail.accepted !== 0 && (
                                      <p className={`status accepted`}>{`${detail.accepted} Accepted`}</p>
                                    )}
                                    {detail.rejected !== 0 && (
                                      <p className={`status rejected`}>{`${detail.rejected} Rejected`}</p>
                                    )}
                                    {detail.cancelled !== 0 && (
                                      <p className={`status cancel`}>{`${detail.cancelled} Cancelled`}</p>
                                    )}
                                  </div>

                              </td>
                              <td  className="action hidePrint">
                                {(detail.deliveryStatus === "pending" || detail.deliveryStatus === "save") ? (
                                  <p
                                    onClick={() => {
                                      this.setState(
                                        {
                                          showSchedule: true,
                                          selectedDeliveryId:
                                            delivery.deliveryId,
                                          selectedPoIdArray: detail.poIdArray,
                                        },
                                        () => {
                                          this.fetchSelectedDeliveryDetails(
                                            detail.poIdArray,
                                            delivery.deliveryId,
                                          );
                                        }
                                      );
                                    }}
                                    className="text-primary cursor-pointer"
                                    style={{ cursor: "pointer" }}
                                  >
                                    Schedule
                                  </p>
                                ) : detail.deliveryStatus === "cancel" ? (
                                 "-"
                                ) : (
                                  <p
                                    className="text-primary cursor-pointer"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      this.setState(
                                        {
                                          loadingChallanId: `${delivery.deliveryId}-${detail.poIdArray[0]}`,
                                          deliveryStatus:detail.deliveryStatus
                                        },
                                        () => {
                                          this.handleChallanClick(
                                            detail.poIdArray,
                                            delivery.deliveryId,
                                            detail.vendorId
                                          );
                                        }
                                      );
                                    }}
                                  >
                                    Challan{" "}
                                    {this.state.loadingChallanId ===
                                    `${delivery.deliveryId}-${detail.poIdArray[0]}` ? (
                                      <span><ButtonLoader /></span>
                                    ) : null}
                                  </p>
                                )}
                              </td>
                            </tr>
                          )
                        );
                      }
                    }
                  )
                ) : (
                  <tr>
                    <td
                      colSpan="8"
                      style={{ textAlign: "center", fontStyle: "italic" }}
                    >
                      {isLoading ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ButtonLoader />
            <span style={{ marginLeft: "10px" }}>Loading...</span>
          </div>
              ) : <p>{(this.state.filterText !== "" || this.state.statusFilter !==  "" || this.state.selectedInstitute !=="") ? "No delivery available as per applied filters.": "No delivery available."}</p>}

                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
         
          {
                            this.state.totalItemsCount  > 0 &&
                            <div className="" style={{ marginTop: '2%' }}>
                                <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', flexWrap: "nowrap", marginBottom: 15, marginTop: "1rem" }}>
                                    <div ref={this.dropdownRef} className="perPageSelectContainer" style={{ fontSize: 13, fontWeight: "bold",  }}>

                                        <select
                                            className={`dropdown ${this.state.dropdownDirection}`}
                                            value={this.state.itemsPerPage}
                                            onChange={(e) =>
                                              this.setState(
                                                {
                                                  itemsPerPage: parseInt(e.target.value, 10),
                                                  activePage: 1,
                                                },
                                                this.fetchDeliveryList
                                              )
                                            }
                                        >
                                            <option value={10} className='entryFont'>Entries Per Page 10</option>
                                            <option value={25} className='entryFont'>Entries Per Page 25</option>
                                            <option value={40} className='entryFont'>Entries Per Page 40</option>
                                            <option value={100} className='entryFont'>Entries Per Page 100</option>
                                            <option value={250} className='entryFont'>Entries Per Page 250</option>
                                        </select>

                                    </div>

                                    {
                                       
                                        <div className="pagignation">
                                            <Pagination
                                                itemsCountPerPage={this.state.itemsPerPage}
                                                totalItemsCount={this.state.totalItemsCount}
                                                pageRangeDisplayed={3}
                                                onChange={this.handlePageChange}
                                                itemClass="page-item"
                                                linkClass="page-link"
                                                activeClass="active"
                                                prevPageText="‹"
                                                nextPageText="›"
                                                firstPageText="«"
                                                lastPageText="»"
                                                activePage = {this.state.activePage}
                                            />
                                            
                                        </div>
                                    }

                                    <p className="" style={{ fontWeight: 'bold', fontSize: 13 }}>Total Records : {this.state.totalItemsCount} </p>
                                </div>
                            </div>
                        }
          <ToastContainer theme="light" />
        </div>
        </div>

        {this.addDeliveryModal()}
        {this.openSchedule()}
        {this.openScheduleConfirmation()}
        {this.openViewChalan()}
        {this.openDeliveryCancelConfirmation()}
      </div>
    );
  }
}
const mapStateToProps = (store) => ({
  iidArray: store.RouteMenuReducer.assignedIIDArray,
  iidDetails: store.RouteMenuReducer.assignedIIDDetails,
});

export default connect(mapStateToProps)(VendorDelivery);
